export const authRefreshModel = (data) => ({
    tokenType: data.token_type,
    accessToken: data.access_token,
    expiresIn: data.expires_in,
    expiresAt: data.expires_at,
    refreshExpiresIn: data.refresh_expires_in,
    refreshExpiresAt: data.refresh_expires_at,
});